const cis = {
	name: 'Zentrales Informationssystem | Zentrale Informationssysteme',
	shortcut: 'Z.I.S.',
	icon: 'fa-fw fa-solid fa-comment-lines',
	fields: {
		cisType: 'Z.I.S. Art',
	},
}

export default cis
